module.exports = __webpack_public_path__ + "img/dingyue-bg.b3b42efb.png";